import { dec } from '@app/shared';
import { INVALID_INPUTS_REASON } from '@/shared/ui/inputs';
import { offsetIsBalanced } from '@/features/payment/allocation-grid';
import type { AllocationRow } from '@/features/payment/allocation-grid';

export interface OffsetForm {
  counterpartyId?: string;
  date: string;
  amount: string | null;
  receivable: AllocationRow[];
  payable: AllocationRow[];
  /** В окне есть поле с неверным значением (оно выделено красным). */
  hasInvalid: boolean;
}

/** Почему взаимозачёт нельзя сохранить сейчас — подсказка на недоступной кнопке и сообщение при
 *  нажатии клавиши; `null`, если можно. `createNew`: новый взаимозачёт ещё и требует, чтобы
 *  разнесение сошлось с суммой на обеих сторонах (у существующего правятся только поля). */
export function getOffsetBlockReason(form: OffsetForm, createNew: boolean): string | null {
  if (form.hasInvalid) return INVALID_INPUTS_REASON;
  if (createNew && !form.counterpartyId) return 'Укажите контрагента';
  if (!form.date) return 'Укажите дату';
  if (!form.amount) return 'Укажите сумму';
  if (dec(form.amount).lte(0)) return 'Сумма должна быть больше нуля';
  if (createNew && !offsetIsBalanced(form.amount, form.receivable, form.payable)) {
    return 'Разнесите всю сумму взаимозачёта по документам с обеих сторон';
  }
  return null;
}
